import React, { useCallback } from 'react'
import * as Layout from 'views/layouts/MainLayout/MainLayout'
import * as Header from 'views/ui/Header/Header'
import { AddButton, SearchInput, useAction, useHelmet, useHistoryPush } from '@agro-club/frontend-shared'
import SeedClassList from './SeedClassList/SeedClassList'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import Routes from './routes'
import SeedClassActions from 'modules/domain/seedClass/duck'
import SeedClassSelectors from 'modules/domain/seedClass/selectors'
import { useSelector } from 'react-redux'
import AuthSelectors from 'modules/domain/auth/selectors'

const SearchInputWrapper = styled.div`
  padding: 18px 24px;
  width: 50%;
`

const SeedClassTable = () => {
  const push = useHistoryPush()
  const filter = useSelector(SeedClassSelectors.filter)
  const filterUpdated = useAction(SeedClassActions.filterUpdated)
  const { t } = useTranslation(['seedClass'])
  const isAdmin = useSelector(AuthSelectors.isAdmin)

  const handleSearchChange = useCallback(
    (search?: string) => {
      filterUpdated({ ...filter, ...{ search } })
    },
    [filterUpdated, filter],
  )

  const metaTitle = t('seedClassesMetaTitle')

  useHelmet({ title: metaTitle })

  return (
    <>
      <Layout.Header>
        <Header.TabsRoot>
          <Header.Tab title={t('list.heading')} isActive onClick={() => push({ route: Routes.List })}>
            {isAdmin && <AddButton to={Routes.Add} />}
          </Header.Tab>
        </Header.TabsRoot>
        <SearchInputWrapper>
          <SearchInput onChange={handleSearchChange} value={filter.search} placeholder={t('list.searchPlaceholder')} />
        </SearchInputWrapper>
      </Layout.Header>
      <Layout.Content>
        <SeedClassList />
      </Layout.Content>
    </>
  )
}

export default SeedClassTable
